<template>
  <Container type="card-full">
    <div class="container">
      <el-form :model="report" ref="form" label-position="left" label-width="100px" v-if="btnFlg">
        <el-form-item v-for="(field, index) in rfields" v-if="field.rfieldisfilter"
          :label="field.rfieldname"
          :key="field.rfieldcode"
          :rules="{}">
          <el-select style="width: 100px" v-model="field.filterexpr"  :clearable="true">
            <el-option v-for="(item, index) in filters" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
          <el-input v-model="field.value" v-if="field.rfieldeditflg === '2' && field.rfieldtype !== 'D' && field.rfieldtype !== 'T'"></el-input>
          <el-date-picker v-model="field.value" v-if="field.rfieldeditflg === '2' && field.rfieldtype === 'D'" type="date" placeholder="选择日期" ></el-date-picker>
          <el-date-picker v-model="field.value" v-if="field.rfieldeditflg === '2' && field.rfieldtype === 'T'" type="datetime" placeholder="选择日期时间" ></el-date-picker>
          <el-select  v-if="field.rfieldeditflg === '3'" v-model="field.value"  :clearable="true">
            <el-option v-for="(item, index) in field.selectdata" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
            <span v-if="field.filterexpr === 'JY'">
              <span>至</span>
              <el-input v-model="field.value1" v-if="field.rfieldeditflg === '2' && field.rfieldtype !== 'D' && field.rfieldtype !== 'T'"></el-input>
              <el-date-picker v-model="field.value1" v-if="field.rfieldeditflg === '2' && field.rfieldtype === 'D'" type="date" placeholder="选择日期" ></el-date-picker>
              <el-date-picker v-model="field.value1" v-if="field.rfieldeditflg === '2' && field.rfieldtype === 'T'" type="datetime" placeholder="选择日期时间" ></el-date-picker>
              <el-select  v-if="field.rfieldeditflg === '3'" v-model="field.value1"  :clearable="true">
                <el-option v-for="(item, index) in field.selectdata" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </span>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item label="">
          <el-button @click="requery">查询</el-button>
          <el-button @click="printReport">打印</el-button>
          <el-button  @click="hideFilter">{{btnTitle}}</el-button>
          <el-button @click="exportData">导出</el-button>
          <el-button @click="close">关闭</el-button>
        </el-form-item>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
              :cols="columns" :showfooter="showfooter" :showPage="false" :resizable="true"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
      </vggrid>
    </div>
  </Container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import mixinIndex from '../../mixin/mixinIndex'
  import * as grdreport from '../../assets/js/grwebapp'
  export default {
    name: 'reportQuery',
    data () {
      return {
        report: this.$route.query,
        btnTitle: '收起',
        btnFlg: true,
        showfooter:false,
        columns: [],
        columntitles: [],
        customCols:[],
        reportsql: '',
        list: [],
        filters: [
          {value: 'EQ', label: '等于'},
          {value: 'NE', label: '不等于'},
          {value: 'GT', label: '大于'},
          {value: 'LT', label: '小于'},
          {value: 'GE', label: '大于等于'},
          {value: 'LE', label: '小于等于'},
          {value: 'JY', label: '介于'},
          {value: 'AL', label: '前匹配'},
          {value: 'BL', label: '后匹配'},
          {value: 'LK', label: '包含'}
        ],
        rfields: [],
        form: {
          value: '',
          selectdefvalue: '0',
          date:'',
          datetime: ''
        }
      }
    },
    created () {
      this.initVue(this.$route)
    },
    activated() {
    },
    beforeRouteUpdate (to, from, next) {
      next()
    },
    beforeRouteLeave (to, from, next) {
      next()
    },
    mounted () {
    },
    computed: {
      ...mapGetters(['cacheVueData'])
    },
    watch: {
      $route (to, from) {
        if (to.name === 'reportQuery') {
          if (to.query.reportid!==from.query.reportid) {
            let data = this.cacheVueData.get('reportQuery'+to.query.reportid)
            if (data) {
              this.report = data.report
              this.columns = data.columns
              this.customCols = data.customCols
              this.rfields = data.rfields
              this.btnTitle = data.btnTitle
              this.btnFlg = data.btnFlg
              this.list = data.list
              this.reportsql = ''
            } else {
              this.initVue(to)
            }
          }
        }
      }
    },
    components: {vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      initVue(to) {
        this.report = to.query
        this.columns = []
        this.customCols = []
        this.rfields = []
        this.btnTitle = '收起'
        this.btnFlg = true
        this.list = []
        this.genReportFilter()
      },
      hideFilter() {
        if (this.btnFlg) {
          this.btnFlg = false
          this.btnTitle = '展开'
        } else {
          this.btnTitle = '收起'
          this.btnFlg = true
        }
      },
      //生成报表的查询条件
      async genReportFilter() {
        let data = await request({
          url: '/xtgl/report/getRfieldListByReportid',
          method: "get",
          params: {reportid: this.report.reportid}
        })
        let column = {}
        await (async ()=>{
          for (let i=0;i<data.length;i++) {
            let item = data[i]
            if (item.rfieldeditflg === '2') {
              data[i].value = ''
              data[i].value1 = ''
              data[i].filterexpr = 'EQ'
              if (item.rfieldtype === 'D' || item.rfieldtype === 'T') {
                data[i].filterexpr = 'JY'
              }
            }
            if (item.rfieldeditflg === '3') {
              let res = await request({
                method: 'get',
                url: '/kfgl/brows/getBrowsDataList',
                params: ({comid: this.$store.getters.loginUser.usercomid,browscode: item.rfieldbrows})
              })
              res.splice(0,0, {
                label: '请选择',
                value: 0
              })
              data[i].filterexpr = 'EQ'
              data[i].selectdata = res
              data[i].value = 0
              data[i].value1 = 0
            }
            column = {}
            column.field = item.rfieldcode
            column.title = item.rfieldname
            column.fieldtype = item.rfieldtype
            column.hide = item.rfieldishide
            column.brows = item.rfieldbrows
            column.getvaluestr = item.rfieldgetvaluestr
            column.setvaluestr = item.rfieldsetvaluestr
            column.calculExpr = item.rfieldcalculexpr
            column.issum = item.rfieldissum
            if (item.rfieldishide === '1') {
              this.customCols.push(
                {
                  field: item.rfieldcode,
                  visible: false
                }
              )
            }
            if (item.rfieldissum === 1) {
              this.sumcols.push(item.rfieldcode)
              this.showfooter = true
            }
            this.columns.push(column)
            this.columntitles.push({
              field: item.rfieldname
            })
          }
        })()
        this.rfields = data
      },
      //生成报表的查询结果表格
      async requery() {
        //先组装查询语句
        let item = {}
        let select = '',from  = '',where = '',orderby = '',having = '',groups = '',sums = '',kzwhere = '',filterstr = ''
        await (async ()=>{
          for (let i=0;i<this.rfields.length;i++) {
            item = this.rfields[i]
            if (i ===0) {
              select = item.reportselect
              from  = item.reportfrom
              where = item.reportwhere
              orderby = item.reportorderby
              having = item.reporthaving
              groups = item.reportgroups
              sums = item.reportsums
              kzwhere = item.reportkzwhere
            }
            if (item.rfieldisfilter === '1' && (item.value || item.value1)) {
              switch (item.filterexpr) {
                case 'EQ'://等于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' = \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' = ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' = convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') = convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'NE'://不等于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' <> \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' <> ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' <> convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') <> convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'GT'://大于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' > \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' > ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' > convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') > convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LT'://小于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' < \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' < ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' < convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') < convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'GE'://大于等于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' >= \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' >= ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' >= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') >= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LE'://小于等于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' <= \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' <= ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' <= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') <= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'JY'://介于
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' >= \'' + item.value + '\''
                      filterstr += ' and ' + item.rfieldexpr + ' <= \'' + item.value1 + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' >= ' + item.value
                      filterstr += ' and ' + item.rfieldexpr + ' <= ' + item.value1
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' >= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      filterstr += ' and ' + item.rfieldexpr + ' <= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') >= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') <= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'AL'://前匹配
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' like \'' + item.value + '%\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' like convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '%\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') like convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '%\')'
                      break
                  }
                  break
                case 'BL'://后匹配
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' like \'%' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' like convert(date,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') like convert(datetime,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LK'://包含
                  switch (item.rfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.rfieldexpr + ' like \'%' + item.value + '%\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.rfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.rfieldexpr + ' like convert(date,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '%\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.rfieldexpr + ') like convert(datetime,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '%\')'
                      break
                  }
                  break
              }
            }
          }
          let wherestr = where + kzwhere
          if (wherestr){
            if (filterstr) {
              wherestr += filterstr
            }
          } else {
            if (filterstr) {
              wherestr = ' where ' + filterstr.substr(4)
            }
          }
          this.reportsql = select + from + wherestr + having + groups + orderby
        })()
        this.list = await request({
          url: '/xtgl/report/getReportdataList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid,sql: this.reportsql}
        })
        //mixinIndex.setCacheVueData('reportQuery'+this.report.reportid,this.$data)
        this.$store.commit('set_cache_data', {key:'reportQuery'+this.report.reportid,data:{
            report:this.report,
            columns:this.columns,
            customCols:this.customCols,
            rfields:this.rfields,
            btnTitle:this.btnTitle,
            btnFlg:this.btnFlg,
            list:this.list}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name+this.report.reportid, vm: this, newRouteName: ''})
      },
      async printReport() {
        let args = {
          report: 'http://120.79.63.75:3002/report/goods.grf',
          data: 'http://127.0.0.1:9600/xtgl/report/getReportdataList?comid='+this.$store.getters.loginUser.usercomid+'&sql='+this.reportsql

        }
        grdreport.webapp_ws_ajax_run(args)
      },
      async getReport() {
        this.report = await request({
          url: '/xtgl/report/getReportById',
          method: "get",
          params: {reportid: this.reportid}
        })
      },
      async exportData() {
        let data = this.list.concat(this.columntitles)
        this.$refs.xGrid.$refs.xGrid.exportData({
          filename: this.report.reportname,
          type: 'csv',
          original: true,
          isHeader: true,
          data: data
        })
      },
      async setReports(reportid) {
//        let index = this.reports.findIndex(item => Number(item.reportid) === Number(reportid))
//        if (index === -1) {
//          this.report = await request({
//            url: '/xtgl/report/getReportById',
//            method: "get",
//            params: {reportid: reportid}
//          })
//          this.reports.push(this.report[0])
//        } else {
//          this.report = this.reports[index]
//        }
//        console.log(index+'===='+this.reportid)
      },
      removeTab(targetName) {
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .el-input{
    width: 200px!important;
  }
  .el-select {
    width: 100px!important;
  }
</style>
